import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  courseScheduleListClear,
  courseScheduleListLoad,
  courseScheduleListLoadSuccess,
} from "../../actions/course-schedule/get-course-schedule.actions";
import {
  editScheduleLoad,
  editScheduleLoadSuccess,
} from "../../actions/course-schedule/edit-course-schedule.actions";
import {
  createScheduleLoad,
  createScheduleLoadSuccess,
} from "../../actions/course-schedule/create-course-schedule.actions";
import {
  editTopicScheduleLoad,
  editTopicScheduleLoadSuccess,
} from "../../actions/course-schedule/edit-course-schedule-topic.actions";
import { Schedule } from "src/app/shared/interfaces/course-schedule";
import { RequestStatus } from "src/app/shared/interfaces/request-status";

export interface CourseScheduleState {
  schedule: Schedule;
  status: RequestStatus;
  error: HttpErrorResponse;
}

const initialState: CourseScheduleState = {
  schedule: {
    id: null,
    start: null,
    stop: null,
    topic_schedules: [],
  },
  status: "IDLE",
  error: null,
};

export const courseScheduleReducer = createReducer(
  initialState,
  on(
    courseScheduleListLoad,
    (state): CourseScheduleState => ({
      ...state,
      // status: "PENDING",
      error: null,
    }),
  ),
  on(
    createScheduleLoad,
    (state): CourseScheduleState => ({
      ...state,
      status: "PENDING",
    }),
  ),
  on(
    editScheduleLoad,
    (state): CourseScheduleState => ({
      ...state,
      status: "PENDING",
    }),
  ),
  on(
    editTopicScheduleLoad,
    (state): CourseScheduleState => ({
      ...state,
      status: "PENDING",
    }),
  ),
  on(
    courseScheduleListLoadSuccess,
    (state, action): CourseScheduleState => ({
      ...state,
      schedule: action.schedule ? action.schedule : initialState.schedule,
      // status: "SUCCESS",
      // tricky approach -
      // we don't want success status here because
      // it is only used to display information modal after post/put changes
      // this action returns get
      error: null,
    }),
  ),
  on(
    editScheduleLoadSuccess,
    (state, action): CourseScheduleState => ({
      ...state,
      schedule: action.schedule,
      status: "SUCCESS",
      error: null,
    }),
  ),
  on(
    createScheduleLoadSuccess,
    (state, action): CourseScheduleState => ({
      ...state,
      schedule: action.schedule,
      status: "SUCCESS",
      error: null,
    }),
  ),
  on(editTopicScheduleLoadSuccess, (state, action): CourseScheduleState => {
    if (!state.schedule) {
      return state;
    }

    const exists = state.schedule.topic_schedules.some(
      (ts) => ts.id === action.schedule.id,
    );

    const updated = exists
      ? state.schedule.topic_schedules.map((ts) =>
          ts.id === action.schedule.id ? action.schedule : ts,
        )
      : [...state.schedule.topic_schedules, action.schedule];

    return {
      ...state,
      schedule: {
        ...state.schedule,
        topic_schedules: updated,
      },
      status: "SUCCESS",
      error: null,
    };
  }),
  on(courseScheduleListClear, (state) => ({
    ...state,
    status: "IDLE",
  })),
);
